<template>
    <div >
        <vxe-toolbar :buttons="toolbarButtons" @button-click="buttonClickEvent" ref="toolbarRef" custom></vxe-toolbar>
        <div style="height:calc(100vh - 140px)">
            <vxe-table id="module" stripe :tree-config="treeConfig" :column-config="{resizable:true}" :row-config="{ isCurrent: true }" ref="tableRef" border
            :data="tableData"   class="table-style" height="100%" align="center">
                <vxe-column type="seq" width="115" tree-node></vxe-column>
                <vxe-column v-for="(column, index) in columns" :field="column.field" :title="column.title"></vxe-column>
                <!-- <vxe-column field="date" title="Date"></vxe-column> -->
                <!-- <vxe-column type="seq" width="70"></vxe-column>
                <vxe-column field="clazz" title="图标"></vxe-column>
                <vxe-column field="path" title="路由路径（英文）"></vxe-column>
                <vxe-column field="label" title="label名称"></vxe-column>
                <vxe-column field="name" title="页面名称（英文）"></vxe-column>
                <!-- <vxe-column field="sort" title="排序值"></vxe-column> -->
                <vxe-column title="操作" width="250">
                    <template #default="{ row }">
                        <vxe-button mode="text" status="success" icon="vxe-icon-edit"
                            @click="editEvent(row)">编辑</vxe-button>
                        <vxe-button mode="text" status="error" icon="vxe-icon-edit"
                            @click="deleteEvent(row)">删除</vxe-button>
                    </template>
                </vxe-column>
            </vxe-table>
        </div>
        <el-dialog  title="新增&修改模块"  :visible.sync="showPopup" :close-on-click-modal="false" destroy-on-close width="50%"
            :before-close="handleClose"  v-dialogDrag :append-to-body="true" :modal="false"   >
            <el-form ref="formRef" :model="formData" label-width="100px">
                <el-form-item label="图标">
                    <div class="chooseIcons">
                        <el-popover placement="top-start" :append-to-body="false" width="100%" trigger="click">
                            <div slot="reference" class="iconDiv">
                                <i :class="userChooseIcon"></i>
                                <div class="iconName">{{ chooseIcons }}</div>
                            </div>
                            <div class="iconList">
                                <i v-for="item in iconListMenu" :key="item" :class="[item, 'icon']" @click="setIcon(item)"
                                    style="font-size: 20px"></i>
                            </div>
                        </el-popover>
                    </div>
                </el-form-item>
                <el-form-item label="路由路径">
                    <el-input v-model.trim="formData.path" placeholder="请输入路由路径"></el-input>
                </el-form-item>
                <el-form-item label="label名称">
                    <el-input v-model.trim="formData.label" placeholder="请输入label名称"></el-input>
                </el-form-item>
                <el-form-item label="页面名称">
                    <el-input v-model.trim="formData.name" placeholder="请输入label名称"></el-input>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input v-model.trim="formData.sort" placeholder="请输入排序"></el-input>
                </el-form-item>
                <el-form-item label="选择父级菜单">
                    <el-select clearable v-model="formData.parentId" placeholder="请选择父级别菜单" style="width: 100%;">
                        <el-option v-for="item in optionsId" :key="item.id" :label="item.label" :value="item.id" >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showPopup = false;">取 消</el-button>
                <el-button type="primary" @click="addSave">确 定</el-button>
            </span>
        </el-dialog>


    </div>
</template>

<script>
import {elementIcons} from '../mixins/icon.js'
export default {
    name: 'module',
    // mixins: [userProfile],
    data() {
        const treeConfig = {
            transform: true,
            rowField: 'id',
            parentField: 'parentId'
        };
        const toolbarButtons = [
            { name: '新增', code: 'add', status: 'primary' },
            // { name: '删除', code: 'del', status: 'error' },
            { name: '展开所有', code: 'expand', status: 'warning' },
            { name: '收起所有', code: 'collapse', status: 'success' },
        ]
        return {
            optionsId:[],
            treeConfig,
            formData: {
                clazz: '',
                path: '',
                label: '',
                sort: '',
                name: '',
                id: '',
                parentId: ''
            },
            showPopup: false,
            tableData: [],
            columns: [],
            toolbarButtons,
            iconListMenu: [],
            userChooseIcon: '',
            chooseIcons: '',

        }
    },
    created() {
        this.getListData();
        this.iconListMenu = elementIcons;

    },
    mounted() {
        const $table = this.$refs.tableRef
        const $toolbar = this.$refs.toolbarRef
        if ($table && $toolbar) {
            $table.connect($toolbar)
        }
    },
    methods: {
        assignPer(row) {
            // this.username = row.name;
            this.$api.getModuleList( ).then(res =>{
                const obj = res;
                this.options = [];
                this.hobbiesList = []
                obj.forEach((item, index) => {
                    this.options.push({
                        label: item.label,
                        value: item.id
                    });
                });
                this.showauth = true;
            })
        },
        editEvent(row) {
            this.showPopup = true;
            // this.formData = row;
            //深拷贝
            this.formData = JSON.parse(JSON.stringify(row));
            delete this.formData.children;
            this.formData.clazz = row.clazz;
            this.chooseIcons = row.clazz;
            this.userChooseIcon = row.clazz;

        },
        deleteEvent(row) {
            if (row.children.length > 0) {
                ///有孩子不允许删除
                this.$message({
                    type: 'error',
                    message: '该菜单下有子菜单，不允许删除'
                });
            } else {
                this.$api.deleteById( row.id ).then(res =>{
                    this.$message({
                        type: 'success',
                        message: '删除成功！'
                    });
                    this.getListData();
                    this.$nextTick(() =>{
                        location.reload();
                    })
                })
            }
        },
        addSave() {
            if (this.formData.clazz === '' || this.formData.path === '' || this.formData.label === '' || this.formData.name === '' || this.formData.sort === '') {
                this.$message.error('请填写完整信息');
            } else {
                this.$api.insModule( this.formData ).then(res =>{
                    this.$message.success('添加成功');
                    this.getListData();
                    this.handleClose();
                    location.reload();
                })
            }

        },
        setIcon(icon) {
            this.userChooseIcon = icon;//将i的样式设为选中的样式el-icon-xxx
            this.chooseIcons = icon;
            this.formData.clazz = icon;
        },
        getListData() {
            this.$api.getTreeMenuList(  ).then(res =>{
                this.tableData = res.tableData;
                this.columns = res.columns;
                this.optionsId = this.tableData;
            })
        },
        buttonClickEvent({ code }) {
            if (code === 'add') {
                this.showPopup = true;
            } else if (code === 'expand') {
                this.expandAllEvent();
            } else if (code === 'collapse') {
                this.clearExpandEvent();
            }

        },
        clearExpandEvent() {
            const $table = this.$refs.tableRef
            if ($table) {
                $table.clearTreeExpand()
            }
        },
        expandAllEvent() {
            const $table = this.$refs.tableRef
            if ($table) {
                $table.setAllTreeExpand(true)
            }
        },
        handleClose() {
            this.showPopup = false;
            this.formData.id = '';
            this.formData.clazz = '';
            this.formData.path = '';
            this.formData.label = '';
            this.formData.sort = '';
            this.formData.name = '';
            this.chooseIcons = '';
            // location.reload();
        },
    },
}
</script>

<style lang="css" scoped>
.chooseIcons {
    width: 100%;

}


.iconList {
    width: 30vw;
    height: 300px;
    overflow-y: scroll;
    overflow-x: hidden;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
}

.icon {
    display: inline-block;
    width: 60px;
    height: 45px;
    color: #000000;
    font-size: 20px;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    cursor: pointer;
    text-align: center;
    line-height: 45px;
    margin: 5px;

}

.icon:hover {
    color: red;
    border-color: red;
}

.iconDiv {
    width: 100%;
    height: 50%;

    display: flex;
    flex-direction: row;
    align-items: center;
}
.iconName {
    width: 100%;
    height: 45px;
    text-align: center;
    border-color: #C0C4CC;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
}

::v-deep .table-style .vxe-table .vxe-cell {
    padding: 0 !important;
    line-height: 1.3vh;
}

::v-deep .el-form-item__label-wrap {
    margin-left: 0px !important;
}

::v-deep .table-style .vxe-body--column {
    padding: 1px !important;
}
</style>